import React from 'react';
import { connect } from 'react-redux';
import ChangePasswordForm from './ChangePasswordForm';
import { SERVICES_RESP, Icons } from '@/configurations';
import {checkFullLayoutRedirect} from '@/helpers/global/index'
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';

class ChangePasswordDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showTips: true,
      showFirstLoginTips: true,
    }
  }

  render() {
    const { language } = this.props;
    const { showTips } = this.state;
    return (
      <React.Fragment>
        <div style={{ width: '600px', padding: '30px' }}>
          {showTips?
          <ChangePasswordForm infoTips callback={() => this.showResultPage()} showFirstLoginTips={this.showFirstLoginTips}/>
          :
          <div className={'success-change-password'}>
                    <Icons.changePasswordSuccess /> 
                  <div>{language.change_password_success}</div>
                  {/* <section className="action_panel">
                    <button className="clear" onClick={() => this.toLogin()}>{language.common_back_login}</button>
                    <button className="submit" onClick={() => this.toHome()}>{language.common_go_directly}</button>
                  </section> */}
          </div>
        }
        </div>
      </React.Fragment>
    )

  }

  showResultPage = () => {
    this.setState({
      showTips: false,
    })
  }

  showFirstLoginTips = (isNeed) => {
    this.setState({
      showFirstLoginTips: isNeed
    })
  }

  toLogin = () => {
    if (iTradeEnv.thirdPartyLogin) {
      window.location.href = iTradeEnv.thirdPartyLink
    } else {
      checkFullLayoutRedirect()
    }
  }

  toHome = () => {
    // this.props.history.push(PATH.TRADE)
  }

  componentDidMount() {
  }
}

export default connect(
  state => ({
    language: state.app.language,
    appConfiguration: state.app.appConfiguration
  })
)(ChangePasswordDialog)